<template>
  <div class="bm-team-detailed" >
    <van-cell-group v-if="currentTeamInfo" >
      <van-cell title="队徽" >
        <template>
          <div class="teamIcon" >
            <div class="upload-profile-lod" v-show="profileLod" >
              <van-loading type="spinner" />
            </div>
            <van-uploader v-show="!profileLod" :after-read="onReadPositive" class="uploaderBnt">
              <img :src="formatterImgSrc(currentTeamInfo.badge)">
            </van-uploader>
          </div>
        </template>
      </van-cell>
      <div v-if="type !== 'invite-team'" >
        <van-cell title="队名" :value="currentTeamInfo.name" />
        <van-cell
          title="本赛用名"
          @click="setValues('MatchTeamName')"
          is-link
          :value="currentTeamInfo.matchTeam && currentTeamInfo.matchTeam.teamAlias" />
        <van-cell
          v-if="isShowGroup"
          title="分组"
          @click="openGroupAction"
          is-link
          :value="currentTeamInfo.matchTeam && currentTeamInfo.matchTeam.groupName" />
      </div>
      <div v-if="type === 'invite-team'" >
        <van-cell title="队名" :value="currentTeamInfo.name" @click="setValues('teamName')" is-link/>
        <van-cell title="地区" :value="currentTeamInfo.location" @click="isShowLocalhost=true" is-link />
        <van-cell title="队服颜色" @click="isShowJesery=true" is-link >
          <img :src="(currentTeamInfo.jesery && currentTeamInfo.jesery.name) | formatJeseryIcon" alt="" style="width: 20px;position: relative;top: 3px;"/>
        </van-cell>
      </div>
    </van-cell-group>

    <van-popup v-model="isShowLocalhost" position="bottom" >
      <van-picker show-toolbar :columns="columns" value-key="name" @change="onChange"
                  @cancel="onHostCancel"
                  @confirm="onHostConfirm" />
    </van-popup>

    <van-popup v-model="PopupShow" position="right" class="popup">
      <div style="width: 100%; height: 30px;" ></div>
      <van-row class="form" type="flex" justify="space-between" style="padding: 0 20px;">
        <van-col span="24" >
          <van-cell-group>
            <van-field v-model="newValue" placeholder="请输入..." />
          </van-cell-group>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="24" style="padding: 0 30px;">
          <van-button round block type="primary" @click="confirmValue" style="margin-top: 15px;">确认</van-button>
          <van-button class="back-btn" round block @click="PopupShow=false" style="margin-top: 10px;">返回</van-button>
        </van-col>
      </van-row>
    </van-popup>

    <!-- group start-->
    <van-popup v-model="isShowPopup" position="bottom" >
      <van-picker
        show-toolbar
        :columns="groups"
        value-key="name"
        :default-index="dIndex"
        @cancel="onCancel"
        @confirm="onConfirm" />
    </van-popup>
    <!-- end -->
    <!-- group length 0 start-->
    <van-popup v-model="isShowNotice" position="bottom" >
      <div class="pop-action">
        <div class="action-btn" @click="onPopCancel">取消</div>
        <div class="action-btn" @click="onPopConfirm">确认</div>
      </div>
      <div class="group-notice">
        <div>还没设置组数</div>
        <div>请前往赛事规则-比赛赛制页设置组数</div>
      </div>
    </van-popup>
    <!-- end -->

    <!-- 队服颜色 start -->
    <van-popup v-model="isShowJesery" position="bottom">
      <div class="jesery-action">
        <div class="action-btn" @click="onJeseryCancel">取消</div>
        <div class="action-btn" @click="onJeseryConfirm">确认</div>
      </div>
      <div class="jesery-box">
        <div class="jesery-item" v-for="(item) in jeseryMap" :key="item.code">
          <div class="iocn-box" style="position: relative">
            <img class="jesery-icon" @click="selectJesery(item)" :src="item.name | formatJeseryIcon" alt="" />
            <img class="checked-icon" v-show="selectedJesery.code == item.code" src="@/assets/images/checked.png" alt="" />
          </div>
        </div>
      </div>
    </van-popup>
    <!-- end-->
    <div class="foot" v-if="type !== 'invite-team'" >
      <van-button type="primary" size="large" @click="confirmSetGroup" >确认</van-button>
      <van-button type="default" size="large" @click="removeTeam" >移除</van-button>
    </div>
    <!--<div class="foot" v-if="type === 'invite-team'" >
      <van-button type ="primary" size="large" @click="confirmSetGroup" >确认</van-button>
    </div>-->
    <div class="invite-foot" v-if="type === 'invite-team'" @click="confirmSetGroup" >
        确认
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import findIndex from 'lodash/findIndex'
import find from 'lodash/find'
import { ImageFormat, varConfig } from '@/utils/'
import { getBMTeamDetailV2, updateBMMatchTeamInfo, updateBMMatchTeamRelations, getBMMatchTeams, getJerseyMapByType } from '@/api/team'
import { getQiniuUploadToken } from '@/api/user'
import { getMatchInfo } from '@/api/match'
import { getCityList } from '@/api/city'

import { Cell, CellGroup, Button, Popup, Field, Row, Col, Picker, Toast, Uploader, Loading } from 'vant'

Vue.use(Cell).use(CellGroup).use(Button).use(Popup).use(Field).use(Row).use(Col).use(Picker).use(Toast).use(Uploader).use(Loading)

export default {
  name: 'teamEdit',
  data() {
    return {
      type: null,
      query: this.$route.query,
      isShowPopup: false,
      isShowGroup: false,
      isShowNotice: false,
      groups: [],
      selectedGroup: {},
      currentTeamInfo: {},
      dIndex: 0,
      isShowLocalhost: false,
      isShowJesery: false,
      sportType: '',
      jeseryMap: [],
      selectedJesery: {},
      columns: [],
      profileLod: false,
      PopupShow: false,
      key: '',
      newValue: ''
    }
  },
  created() {
    this.teamId = this.query.teamId
    this.matchId = this.query.matchId
    this.type = this.query.type
    this.getQiniuToken()
    this.getBMTeamDetailV2()
    this.cityList = getCityList()
  },
  computed: {
    formatterImgSrc() {
      return function(src) {
        return ImageFormat.imageView(src, 100, 100)
      }
    }
  },
  methods: {
    getBMTeamDetailV2() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId
      }
      getBMTeamDetailV2(params).then((response) => {
        let data = response.data
        this.currentTeamInfo = data.currentTeamInfo
        if (this.type !== 'invite-team') {
          this.getBMMatchTeams()
        }
        this.findCity(this.currentTeamInfo.location)
        this.getMatchInfo()
      })
    },
    onReadPositive(file) {
      this.profileLod = true
      this.uploadFile(file).then(res => {
        if (res) {
          this.currentTeamInfo.badge = res.hash
          this.profileLod = false
        }
      })
    },
    uploadFile(file) {
      let formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      }
      return new Promise((resolve, reject) => {
        axios.post(varConfig.qiniuUpload, formData, config).then(res => {
          const data = res.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.qiniuToken = data.token
      }).catch(() => {
        Toast('七牛Token获取失败')
      })
    },

    confirmSetGroup() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId,
        name: this.currentTeamInfo.name,
        badge: this.currentTeamInfo.badge,
        groupId: this.currentTeamInfo.matchTeam.groupId,
        areaId: this.currentTeamInfo.areaId,
        color: this.currentTeamInfo.jesery && this.currentTeamInfo.jesery.code,
        teamAlias: this.currentTeamInfo.matchTeam && this.currentTeamInfo.matchTeam.teamAlias
      }
      updateBMMatchTeamInfo(params).then((response) => {
        const data = response.data
        if (data && data.update) {
          Toast('更新成功')
          this.$router.go(-1)
        }
      })
    },
    removeTeam() {
      let params = {
        matchId: this.matchId,
        teamIds: this.teamId,
        link: 0
      }
      updateBMMatchTeamRelations(params).then((response) => {
        if (response) {
          Toast('删除成功')
          this.$router.push({
            path: '/participate/team-list',
            query: {
              matchId: this.matchId
            }
          })
        }
      })
    },
    openGroupAction: function () {
      if (this.groups.length > 0) {
        this.isShowPopup = true
      } else {
        this.isShowNotice = true
      }
    },
    onCancel: function () {
      this.isShowPopup = false
    },
    onConfirm: function (value, index) {
      this.currentTeamInfo.matchTeam.groupId = value.id
      this.currentTeamInfo.matchTeam.groupName = value.name
      this.isShowPopup = false
    },
    onPopCancel: function () {
      this.isShowNotice = false
    },
    onPopConfirm: function (value, index) {
      this.isShowNotice = false
    },
    onJeseryConfirm() {
      this.currentTeamInfo.jesery = this.selectedJesery
      this.isShowJesery = false
    },
    onJeseryCancel() {
      this.isShowJesery = false
    },
    getJerseyMapByType() {
      this.jeseryMap = getJerseyMapByType(this.sportType)
    },
    selectJesery(jesery) {
      this.selectedJesery = jesery
    },
    onHostConfirm(value, index) {
      this.currentTeamInfo.areaId = value[1].id
      this.currentTeamInfo.location = value[0] + '|' + value[1].name
      this.isShowLocalhost = false
    },
    onHostCancel() {
      this.isShowLocalhost = false
    },
    onChange(picker, values) {
      picker.setColumnValues(1, this.cityList[values[0]])
    },
    getBMMatchTeams: function () {
      const params = {
        matchId: this.query.matchId
      }
      getBMMatchTeams(params).then(response => {
        const data = response.data
        if (data.match && data.match.groups) {
          this.isShowGroup = true
          this.groups = data.match && data.match.groups
          if (this.groups.length > 0) {
            const matchTeam = this.currentTeamInfo.matchTeam
            this.dIndex = findIndex(this.groups, function (item) {
              return item.id === matchTeam.groupId
            })
          }
        } else {
          this.isShowGroup = false
        }
      })
    },
    setValue() {
      this.isShowLocalhost = false
    },
    getMatchInfo: function () {
      getMatchInfo(this.query.matchId).then(response => {
        const data = response.data
        this.sportType = data.match && data.match.sportType
        this.getJerseyMapByType(this.sportType)
        const self = this
        if (this.currentTeamInfo.color) {
          this.currentTeamInfo.jesery = find(this.jeseryMap, function (item) {
            return item.code === parseInt(self.currentTeamInfo.color)
          })
          this.selectedJesery = this.currentTeamInfo.jesery ? this.currentTeamInfo.jesery : []
        }
      })
    },
    findCity(location) {
      let areaIndex = 1
      let areaName = '上海'
      if (location) {
        const arr = location.split('|')
        areaName = arr[0]
        const areaArr = this.cityList[arr[0]]
        areaIndex = findIndex(areaArr, function (item) {
          return item.name === arr[1]
        })
      }
      this.columns = [
        {
          values: Object.keys(this.cityList),
          className: 'column1'
        },
        {
          values: this.cityList[areaName],
          className: 'column2',
          defaultIndex: areaIndex
        }
      ]
    },
    setValues(key) {
      this.key = key
      if (key === 'teamName') {
        this.newValue = this.currentTeamInfo.name
      } else if (key === 'matchTeamName') {
        this.newValue = this.currentTeamInfo.matchTeam && this.currentTeamInfo.matchTeam.teamAlias
      }
      this.PopupShow = true
    },
    confirmValue() {
      if (this.key === 'teamName') {
        this.currentTeamInfo.name = this.newValue
      } else if (this.key === 'matchTeamName') {
        this.currentTeamInfo.matchTeam.teamAlias = this.newValue
      }
      this.PopupShow = false
    }
  },
  filters: {
    formatJeseryIcon: function (value) {
      if (value) {
        return varConfig.qiniuCdn + '/' + value
      }
    }
  }
}
</script>

<style lang="stylus">
  .bm-team-detailed
    background-color: white
    width 100%
    height: 100%
    position absolute
    .form
      :after
        border-width: 1px 0;
    .van-cell-group
      .van-cell:not(:last-child)::after
        right: 15px
      .van-cell:first-child
        .van-cell__title
          display flex
          align-content center
          align-items: center;
      .van-cell
        font-size:14px;
        font-weight:300;
        color:rgba(74,74,74,1);
        background-color white !important
        .van-icon::before
          color: #000000
    .teamIcon
      width 50px
      height 50px
      border-radius:2px;
      float: right
      position: relative
      img
        width 50px
        height 50px
      .upload-profile-lod
        position absolute
        left: 0;
        top: 0;
        width 100%
        height: 100%
        background-color white
        .van-loading
          left: 50%
          top: 50%
          transform translate(-50%, -50%)
    .foot
      position absolute
      bottom 0
      left 50%
      transform translate(-50%, 0)
      padding: 0 40px
      width: calc(100% - 80px)
      background-color white !important
      .van-button
        border none
        font-size:16px;
        font-weight normal
        color: #EC4E4E;
        line-height:25px;
      .van-button--primary
        background-color #32A377
        font-size:16px;
        font-weight:400;
        color:rgba(255,255,255,1);
    .popup
      width 100%
      height: 100%
      background-color white
      .van-button
        background-color #32a377
      .back-btn
        background-color #FFFFFF
    .form
      padding: 0 15px;
    .group-notice
      color: #9b9b9b;
      font-size: 14px
      min-height: 135px;
      text-align: center;
      padding-top: 24px;
    .pop-action
      display: flex;
      height: 44px;
      line-height: 44px;
      -webkit-box-pack: justify;
      justify-content: space-between
      .action-btn
        color: #9b9b9b;
        padding: 0 15px;
        font-size: 14px;
  .jesery-box
    padding: 10px 15px
    min-height: 135px
    .jesery-item
      width: 25%
      float: left
      text-align: center
      .jesery-icon
        width: 30px
      .checked-icon
        width: 16px
        position: absolute;
        right: 18px;
        bottom: 4px;
  .jesery-action
    display: flex;
    height: 44px;
    line-height: 44px;
    -webkit-box-pack: justify;
    justify-content: space-between
    .action-btn
      color: #1989fa;
      padding: 0 15px;
      font-size: 14px;
  .invite-foot
    padding: 10px 0
    background: rgba(250,250,250,1);
    color: #32A377
    font-size 20px
    text-align center
    position fixed
    bottom: 0
    width: 100%
    a
      font-size:18px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(50,163,119,1);
</style>



// WEBPACK FOOTER //
// src/pages/team/participate/team-detailed.vue